import { render, staticRenderFns } from "./SchuelerausweisModal.vue?vue&type=template&id=40c42b19"
import script from "./SchuelerausweisModal.vue?vue&type=script&lang=js"
export * from "./SchuelerausweisModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports